import {
  Card,
  Table,
  Tag,
  Typography,
  Select,
  InputNumber,
  Pagination,
  Space,
  Button,
  notification,
  Modal,
  Popover,
  Image,
  Input,
  Popconfirm,
} from "antd";
import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  getNonVerifiedPurchaseList,
  getPurchaseCategories,
  getChecks,
  verifyNonVerifiedPurchaseV4,
  rejectNonVerifiedPurchaseV4,
  getNonApprovedOrders,
} from "../api/api";
import moment from "moment";
import { Link } from "react-router-dom";
import { encodeProductCode } from "../utils/Extra";
import { siteInfo } from "../utils/SiteInfo";
import Spinner from "../components/Spinner";
import Status from "../components/Status";

const { Text, Title } = Typography;
const { Column } = Table;
const { Option } = Select;

export default function ApprovalCenter() {
  const [data, setData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actioned, setActioned] = useState({});
  const modifiedOrders = useRef({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const pageSize = 300;

  // Batch Update States
  const [batchModal, setBatchModal] = useState({ open: false, customer: null });
  const [refreshKeys, setRefreshKeys] = useState({});
  const [batchValues, setBatchValues] = useState({
    charge_category: null,
    category: null,
    shipping_route: null,
    belt_lot: null,
    shipping_rate: null,
    checks: [],
    purchase_note: "",
  });

  useEffect(() => {
    getPurchaseCategories((cats) => setCategories(cats || []), null);
    getChecks((cks) => setChecks(cks || []), null);
  }, []);

  useEffect(() => {
    getNonApprovedOrders(setData, filter);
  }, [filter]);

  const getTotalQty = (items) => {
    if (items && items.length > 0) {
      return items.reduce((total, item) => total + (item.quantity || 0), 0);
    }
    return 0;
  };

  const getApproxShippingCharge = (weight, method) => {
    if (method === "sea") {
      return "৳" + Math.round(weight * 170) + " - ৳" + Math.round(weight * 400);
    }

    return "৳" + Math.round(weight * 700) + " - ৳" + Math.round(weight * 1100);
  };

  const getPaginatedCustomers = (data) => {
    if (!data?.customers) return [];
    const startIndex = (page - 1) * pageSize;
    return data.customers.slice(startIndex, startIndex + pageSize);
  };

  const handleOrderChange = (id, key, value) => {
    modifiedOrders.current = {
      ...modifiedOrders.current,
      [id]: {
        ...modifiedOrders.current[id],
        [key]: value,
      },
    };
  };

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const handleApprove = (record) => {
    const changes = modifiedOrders.current[record._id] || {};
    let foundCategory = categories.find((cat) => cat._id === changes?.category);
    console.log(changes);

    const payload = {
      _id: record._id,
      code: record.code,
      shipping_category: changes.category || null,
      product_category: foundCategory?.name,
      shipping_route: changes.shipping_route || null, // Note: User code used 'route' key but select has guangzhou/hongkong
      shipping_charge: changes.shipping_rate || null, // InputNumber
      checks: changes.checks || record.product?.checks || [],
      note: changes.purchase_note || "",
      charge_category:
        changes.charge_category || record?.shipment?.charge_category,
      belt_lot: changes.belt_lot || record?.shipment?.belt_lot,
    };

    if (
      !payload.shipping_charge ||
      !payload.shipping_route ||
      !payload.shipping_category
    ) {
      openNotificationWithIcon(
        "error",
        "Invalid Data",
        "Please fill all the required fields",
      );
      return;
    }

    setLoading(record?._id);
    verifyNonVerifiedPurchaseV4(record?._id, payload, (res, message) => {
      setLoading(null);
      console.log(res);

      if (res) {
        setActioned({
          ...actioned,
          [record?._id]: "approved",
        });
        openNotificationWithIcon(
          "success",
          "Success",
          "Order Approved Successfully",
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Error",
          message || "Something went wrongxxx",
        );
      }
    });
  };

  const handleReject = (record) => {
    setLoading(record._id);
    rejectNonVerifiedPurchaseV4(record._id, {}, (res, message) => {
      setLoading(null);
      if (res) {
        setActioned({
          ...actioned,
          [record._id]: "rejected",
        });
        openNotificationWithIcon(
          "success",
          "Success",
          "Order Rejected Successfully",
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Error",
          message || "Something went wrong",
        );
      }
    });
  };

  const handleBatchSave = () => {
    const { customer } = batchModal;
    if (!customer) return;

    customer.orders.forEach((order) => {
      const currentChanges = modifiedOrders.current[order._id] || {};
      const updates = {};
      Object.entries(batchValues).forEach(([key, val]) => {
        if (
          val !== null &&
          val !== "" &&
          !(Array.isArray(val) && val.length === 0)
        ) {
          updates[key] = val;
        }
      });

      modifiedOrders.current[order._id] = {
        ...currentChanges,
        ...updates,
      };
    });

    // Force re-render of inputs for this customer
    setRefreshKeys((prev) => ({
      ...prev,
      [customer._id]: Date.now(),
    }));

    setBatchModal({ open: false, customer: null });
    setBatchValues({
      charge_category: null,
      category: null,
      shipping_route: null,
      belt_lot: null,
      shipping_rate: null,
      checks: [],
      purchase_note: "",
    });
  };

  return (
    <div>
      <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
        <Button
          type="primary"
          onClick={() => setFilter({})}
          style={{
            backgroundColor: !filter.method ? siteInfo.navColor : "#fff",
            color: !filter.method ? "#fff" : "#000",
          }}
        >
          All Orders
        </Button>
        <Button
          type="primary"
          onClick={() => {
            if (filter?.method === "air") {
              setFilter({});
            } else {
              setFilter({ ...filter, method: "air" });
            }
          }}
          style={{
            backgroundColor:
              filter.method === "air" ? siteInfo.navColor : "#fff",
            color: filter.method === "air" ? "#fff" : "#000",
          }}
        >
          Air Orders
        </Button>
        <Button
          type="primary"
          onClick={() => {
            if (filter?.method === "sea") {
              setFilter({});
            } else {
              setFilter({ ...filter, method: "sea" });
            }
          }}
          style={{
            backgroundColor:
              filter.method === "sea" ? siteInfo.navColor : "#fff",
            color: filter.method === "sea" ? "#fff" : "#000",
          }}
        >
          Sea Orders
        </Button>
      </div>

      {data && (
        <div
          className="mt1 flex"
          style={{
            gap: 16,
          }}
        >
          <Card
            style={{
              width: 280,
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tag color="magenta">{data?.order_count || 0}</Tag>
              <h3 className="mt05">Total Order</h3>
            </div>
          </Card>
        </div>
      )}

      {useMemo(
        () => (
          <>
            {getPaginatedCustomers(data)?.map((customer, customerIndex) => (
              <Card
                key={customer._id}
                style={{ marginBottom: "16px" }}
                title={
                  <div>
                    <Link to={`/crm/customer/${customer._id}`}>
                      {customer.name +
                        " - " +
                        (customer.phone ||
                          customer.email ||
                          customer.emergency_phone ||
                          "")}
                    </Link>
                  </div>
                }
                extra={
                  <Button
                    onClick={() => setBatchModal({ open: true, customer })}
                  >
                    Edit All
                  </Button>
                }
                bodyStyle={{
                  padding: 16,
                }}
              >
                <Table
                  dataSource={customer.orders}
                  rowKey={(record) => record._id}
                  pagination={false}
                  bordered
                  size="small"
                  rowClassName={(record) =>
                    record.risky ? "riskyRowBackground" : ""
                  }
                  rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys, selectedRows) => {
                      console.log(
                        `selectedRowKeys: ${selectedRowKeys}`,
                        "selectedRows: ",
                        selectedRows,
                      );
                    },
                  }}
                >
                  <Column
                    title="Order"
                    key="code"
                    render={(text, record) => (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            flexDirection: "column",
                          }}
                          className="mb1"
                        >
                          {" "}
                          <Image
                            src={record.product?.image}
                            alt="product"
                            style={{
                              width: 50,
                              height: 50,
                              objectFit: "cover",
                            }}
                          />
                          <a
                            href={
                              record?.product?.code?.includes("abb-")
                                ? `https://skybuybd.com/product/${encodeProductCode(
                                    record?.product?.code,
                                  )}`
                                : `https://skyone.global/product/${encodeProductCode(
                                    record?.product?.code,
                                  )}`
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                marginRight: 0,
                                color:
                                  record?.company === "skyone"
                                    ? "#FF3F33"
                                    : siteInfo.navColor,
                              }}
                            >
                              {record?.product?.title?.slice(0, 20)}
                            </span>
                          </a>
                        </div>
                        <Link to={`/order/${record.code}`}>
                          <p
                            style={{
                              color: record.risky ? "red" : "#000",
                              marginRight: 6,
                            }}
                          >
                            #{record.code || record._id}
                          </p>
                          <Text
                            style={{
                              fontSize: 13,
                            }}
                          >
                            {moment(record.createdAt).format("DD MMM, YYYY")}
                          </Text>
                        </Link>
                        <div className="mt05">
                          <Status name={record?.shipment?.method} />
                        </div>
                        <div className="mt05">
                          {record?.customer_note ? (
                            <Popover
                              content={<div>{record?.customer_note}</div>}
                              title="Note"
                              trigger="hover"
                            >
                              <span style={{ color: "red" }}>
                                Note: {record?.customer_note?.slice(0, 20)} ...
                              </span>
                            </Popover>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )}
                  />
                  <Column
                    title="Product Price"
                    align="center"
                    key="grand_total"
                    render={(text, record) => (
                      <Text>৳{record.grand_total}</Text>
                    )}
                  />
                  <Column
                    title="Total Weight"
                    align="center"
                    key="grand_total"
                    render={(text, record) => (
                      <Text>
                        {record?.product?.weight
                          ? parseFloat(
                              getTotalQty(record.items) *
                                record?.product?.weight,
                            ).toFixed(2)
                          : 0}
                      </Text>
                    )}
                  />

                  <Column
                    title="Approx Shipping Charge"
                    align="center"
                    key="grand_total"
                    render={(text, record) => (
                      <Text
                        style={{
                          fontSize: 13,
                        }}
                      >
                        {record?.product?.weight
                          ? getApproxShippingCharge(
                              getTotalQty(record.items) *
                                record?.product?.weight,
                              record?.shipment?.method,
                            )
                          : "-"}
                      </Text>
                    )}
                  />
                  <Column
                    title="Category"
                    key="category"
                    render={(text, record) => (
                      <Select
                        key={`cat_${record._id}_${refreshKeys[customer._id]}`}
                        showSearch
                        style={{ width: 160 }}
                        placeholder="Select Category"
                        optionFilterProp="children"
                        defaultValue={
                          modifiedOrders.current[record._id]?.category ||
                          record.product?.category?._id
                        }
                        onChange={(value) => {
                          if (value) {
                            handleOrderChange(record._id, "category", value);
                            setRefreshKeys((prev) => ({
                              ...prev,
                              [customer._id]: Date.now(),
                            }));
                          }
                        }}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categories.map((cat) => (
                          <Option key={cat._id} value={cat._id}>
                            {cat.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />

                  <Column
                    title="Shipping Category"
                    key="charge_category"
                    render={(text, record) => (
                      <Select
                        key={`charge_cat_${record._id}_${refreshKeys[customer._id]}`}
                        showSearch
                        style={{ width: 200, textTransform: "capitalize" }}
                        placeholder="Select Shipping Charge"
                        optionFilterProp="children"
                        defaultValue={
                          modifiedOrders.current[record._id]?.charge_category ??
                          record.product?.shipment?.charge_category
                        }
                        onChange={(value) => {
                          if (value || value === 0) {
                            let found =
                              record?.shipment?.charge_categories?.find(
                                (cat) => cat._id === value,
                              );
                            handleOrderChange(
                              record._id,
                              "charge_category",
                              value,
                            );
                            let rate = found?.charge || "";
                            let route = found?.route || "";

                            handleOrderChange(
                              record._id,
                              "shipping_route",
                              route,
                            );
                            handleOrderChange(
                              record._id,
                              "shipping_rate",
                              rate,
                            );

                            setRefreshKeys((prev) => ({
                              ...prev,
                              [customer._id]: Date.now(),
                            }));
                          }
                        }}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {record?.shipment?.charge_categories?.map((cat) => (
                          <Option
                            key={cat._id}
                            value={cat._id}
                            style={{
                              textTransform: "capitalize",
                            }}
                          >
                            {/* {cat.title + " " + cat?.route + " " + cat?.charge} */}
                            <div>
                              <p
                                style={{
                                  fontSize: 15,
                                }}
                              >
                                {cat.title +
                                  " " +
                                  cat?.route +
                                  " " +
                                  cat?.charge}
                              </p>
                              <p
                                style={{
                                  color: "#888",
                                  fontSize: 13,
                                }}
                              >
                                {cat.description}
                              </p>
                            </div>
                          </Option>
                        ))}
                        <Option value={0}>Custom</Option>
                      </Select>
                    )}
                  />
                  <Column
                    title="Shipping Route"
                    key="route"
                    render={(text, record, index) => (
                      <Select
                        key={`route_${record._id}_${refreshKeys[customer._id]}`}
                        style={{ width: 100 }}
                        defaultValue={
                          modifiedOrders.current[record._id]?.shipping_route ||
                          record.shipment?.route
                        }
                        onChange={(value) => {
                          handleOrderChange(
                            record._id,
                            "shipping_route",
                            value,
                          );

                          setRefreshKeys((prev) => ({
                            ...prev,
                            [customer._id]: Date.now(),
                          }));
                        }}
                        disabled={
                          modifiedOrders.current[record._id]
                            ?.charge_category !== 0
                        }
                      >
                        <Option value="guangzhou">Guangzhou</Option>
                        <Option value="hongkong">Hong Kong</Option>
                      </Select>
                    )}
                  />
                  <Column
                    title="Shipping Rate"
                    key="rate"
                    render={(text, record) => (
                      <InputNumber
                        key={`rate_${record._id}_${refreshKeys[customer._id]}`}
                        style={{ width: 80 }}
                        defaultValue={
                          modifiedOrders.current[record._id]?.shipping_rate
                        }
                        onChange={(value) =>
                          handleOrderChange(record._id, "shipping_rate", value)
                        }
                        disabled={
                          modifiedOrders.current[record._id]
                            ?.charge_category !== 0
                        }
                      />
                    )}
                  />
                  <Column
                    title="Belt Lot"
                    key="belt_lot"
                    render={(text, record, index) => (
                      <>
                        <Select
                          key={`belt_lot_${record._id}_${refreshKeys[customer._id]}`}
                          style={{ width: 100 }}
                          defaultValue={
                            modifiedOrders.current[record._id]?.belt_lot ||
                            record.shipment?.belt_lot
                          }
                          onChange={(value) =>
                            handleOrderChange(record._id, "belt_lot", value)
                          }
                          disabled={
                            modifiedOrders.current[record._id]
                              ?.shipping_route !== "guangzhou"
                          }
                        >
                          <Option value={1}>1</Option>
                          <Option value={2}>2</Option>
                          <Option value={3}>3</Option>
                          <Option value={4}>4</Option>
                        </Select>
                      </>
                    )}
                  />
                  <Column
                    title="Checks"
                    key="checks"
                    render={(text, record) => (
                      <Select
                        key={`checks_${record._id}_${
                          refreshKeys[customer._id]
                        }`}
                        mode="multiple"
                        style={{ width: 160 }}
                        placeholder="Select Checks"
                        defaultValue={
                          modifiedOrders.current[record._id]?.checks ||
                          record.product?.checks ||
                          []
                        }
                        onChange={(value) =>
                          handleOrderChange(record._id, "checks", value)
                        }
                      >
                        {checks.map((check) => (
                          <Option key={check._id} value={check._id}>
                            {check.title}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                  <Column
                    title="Purchase Note"
                    key="purchase_note"
                    render={(text, record) => (
                      <Input
                        key={`purchase_note_${record._id}_${
                          refreshKeys[customer._id]
                        }`}
                        style={{ width: 120 }}
                        defaultValue={
                          modifiedOrders.current[record._id]?.purchase_note
                        }
                        onChange={(e) =>
                          handleOrderChange(
                            record._id,
                            "purchase_note",
                            e.target.value,
                          )
                        }
                      />
                    )}
                  />
                  <Column
                    title="Action"
                    key="checks"
                    render={(text, record) => (
                      <Space>
                        <Button
                          type="primary"
                          onClick={() => handleApprove(record)}
                          loading={loading === record._id}
                          disabled={actioned[record._id]}
                        >
                          Approve
                        </Button>

                        <Popconfirm
                          placement="topLeft"
                          title={`Deny`}
                          onConfirm={() => {
                            handleReject(record);
                          }}
                          okText="Deny"
                          cancelText="Cancel"
                          okButtonProps={{ loading: loading === record._id }}
                        >
                          <Button
                            type="primary"
                            danger
                            loading={loading === record._id}
                            disabled={actioned[record._id]}
                          >
                            Reject
                          </Button>
                        </Popconfirm>
                      </Space>
                    )}
                  />
                </Table>
              </Card>
            ))}
          </>
        ),
        [data, refreshKeys, page, actioned],
      )}
      {!data && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "92vh",
          }}
        >
          <Spinner />
        </div>
      )}
      {data?.customers?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <Pagination
            current={page}
            total={data.customers.length}
            pageSize={pageSize}
            onChange={(p) => {
              setPage(p);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            showSizeChanger={false}
          />
        </div>
      )}

      <Modal
        title={`Update all orders of - ${batchModal.customer?.name}`}
        open={batchModal.open}
        onOk={handleBatchSave}
        onCancel={() => setBatchModal({ open: false, customer: null })}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: 16,
          }}
        >
          <div
            style={{
              marginTop: 8,
              marginBottom: 8,
            }}
          >
            <p className="mb05" strong>
              Category
            </p>
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Select Category"
              optionFilterProp="children"
              value={batchValues.category}
              onChange={(val) =>
                setBatchValues((prev) => ({ ...prev, category: val }))
              }
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {categories.map((cat) => (
                <Option key={cat._id} value={cat._id}>
                  {cat.name}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <p className="mb05" strong>
              Shipping Category
            </p>
            <Select
              showSearch
              style={{ width: "100%", textTransform: "capitalize" }}
              placeholder="Select Shipping Category"
              optionFilterProp="children"
              value={batchValues.charge_category}
              onChange={(value) => {
                let found =
                  batchModal?.customer?.orders?.[0]?.shipment?.charge_categories?.find(
                    (cat) => cat._id === value,
                  );

                let rate = found?.charge || "";
                let route = found?.route || "";

                setBatchValues((prev) => ({
                  ...prev,
                  charge_category: value,
                  ...(found && { shipping_route: route, shipping_rate: rate }),
                }));
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {batchModal?.customer?.orders?.[0]?.shipment?.charge_categories?.map(
                (cat) => (
                  <Option
                    key={cat._id}
                    value={cat._id}
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {cat.title + " " + cat?.route + " " + cat?.charge}
                  </Option>
                ),
              )}
              <Option value={0}>Custom</Option>
            </Select>
          </div>
          <div>
            <p className="mb05" strong>
              Shipping Route
            </p>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Route"
              value={batchValues.shipping_route}
              onChange={(val) =>
                setBatchValues((prev) => ({ ...prev, shipping_route: val }))
              }
              disabled={batchValues.charge_category !== 0}
            >
              <Option value="guangzhou">Guangzhou</Option>
              <Option value="hongkong">Hong Kong</Option>
            </Select>
          </div>
          <div>
            <p className="mb05" strong>
              Shipping Rate
            </p>
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Shipping Rate"
              value={batchValues.shipping_rate}
              onChange={(val) =>
                setBatchValues((prev) => ({ ...prev, shipping_rate: val }))
              }
              disabled={batchValues.charge_category !== 0}
            />
          </div>
          <div>
            <p className="mb05" strong>
              Belt Lot
            </p>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Belt Lot"
              value={batchValues.belt_lot}
              onChange={(val) =>
                setBatchValues((prev) => ({ ...prev, belt_lot: val }))
              }
              disabled={batchValues.shipping_route !== "guangzhou"}
            >
              <Option value={1}>1</Option>
              <Option value={2}>2</Option>
              <Option value={3}>3</Option>
              <Option value={4}>4</Option>
            </Select>
          </div>

          <div
            style={{
              marginTop: 8,
            }}
          >
            <p className="mb05" strong>
              Checks
            </p>
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Checks"
              value={batchValues.checks}
              onChange={(val) =>
                setBatchValues((prev) => ({ ...prev, checks: val }))
              }
            >
              {checks.map((check) => (
                <Option key={check._id} value={check._id}>
                  {check.title}
                </Option>
              ))}
            </Select>
          </div>
          <div>
            <p className="mb05" strong>
              Purchase Note
            </p>
            <Input
              style={{ width: "100%" }}
              placeholder="Purchase Note"
              value={batchValues.purchase_note}
              onChange={(e) =>
                setBatchValues((prev) => ({
                  ...prev,
                  purchase_note: e.target.value,
                }))
              }
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
